var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2196",
    "data-name": "Rettangolo 2196",
    width: 19.287,
    height: 14.58,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2194",
    "data-name": "Rettangolo 2194",
    width: 4.108,
    height: 7.639,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5035",
    "data-name": "Raggruppa 5035",
    transform: "translate(-120 -409)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2197",
    "data-name": "Rettangolo 2197",
    width: 24,
    height: 24,
    transform: "translate(120 409)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5034",
    "data-name": "Raggruppa 5034",
    transform: "translate(122 414)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5033",
    "data-name": "Raggruppa 5033",
    transform: "translate(0.001 0)",
    clipPath: "url(#clip-path)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5032",
    "data-name": "Raggruppa 5032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5031",
    "data-name": "Raggruppa 5031",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9271",
    "data-name": "Tracciato 9271",
    d: "M32.333,7.291A7.29,7.29,0,1,1,25.043,0a7.29,7.29,0,0,1,7.29,7.29",
    transform: "translate(-15.408 -0.001)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9272",
    "data-name": "Tracciato 9272",
    d: "M46.6,24.418a4.73,4.73,0,1,1-4.73-4.73,4.73,4.73,0,0,1,4.73,4.73",
    transform: "translate(-32.235 -17.088)",
    fill: "#8dcbca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9273",
    "data-name": "Tracciato 9273",
    d: "M38.307,24.879a4.6,4.6,0,0,1,6.442-4.213,4.729,4.729,0,1,0-3.74,8.4,4.6,4.6,0,0,1-2.7-4.189",
    transform: "translate(-32.235 -17.088)",
    fill: "#1d918d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5030",
    "data-name": "Raggruppa 5030",
    transform: "translate(11.732 1.115)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5029",
    "data-name": "Raggruppa 5029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5028",
    "data-name": "Raggruppa 5028",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9274",
    "data-name": "Tracciato 9274",
    d: "M92.645,13.505a.171.171,0,0,1-.188-.146,5.858,5.858,0,0,0-1.72-3.445,5.551,5.551,0,0,0-1.8-1.143.171.171,0,0,1,.124-.319,5.891,5.891,0,0,1,1.91,1.213A6.2,6.2,0,0,1,92.8,13.312a.171.171,0,0,1-.151.194",
    transform: "translate(-88.829 -8.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9275",
    "data-name": "Tracciato 9275",
    d: "M116.072,53.6h0a.171.171,0,0,1-.118-.207,5.716,5.716,0,0,0,.178-1.539.171.171,0,0,1,.342-.008,6.054,6.054,0,0,1-.189,1.633.171.171,0,0,1-.213.121",
    transform: "translate(-112.366 -45.972)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9276",
    "data-name": "Tracciato 9276",
    d: "M2.306,88.3c-.025.559.25,1.034.6,1.034h.013c.349,0,.624-.475.6-1.034l-.02-.469L2.375,86.709Z",
    transform: "translate(-2 -75.257)",
    fill: "#8dcbca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9277",
    "data-name": "Tracciato 9277",
    d: "M2.99,80.341l1.08,1.076-.021-.476L3.009,79.9Z",
    transform: "translate(-2.595 -69.351)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9278",
    "data-name": "Tracciato 9278",
    d: "M2.838,83.673l1.121,1.118-.022-.5-1.08-1.076Z",
    transform: "translate(-2.463 -72.221)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9279",
    "data-name": "Tracciato 9279",
    d: "M3.639,42.034l-.168,3.873.947.944-.209-4.816a.429.429,0,0,1,.032-.122H3.607a.433.433,0,0,1,.032.122",
    transform: "translate(-3.013 -36.377)",
    fill: "#8dcbca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9280",
    "data-name": "Tracciato 9280",
    d: "M1.869,4.576c0-.056-.031-.1-.066-.1h0c-.037,0-.066.048-.066.107L1.665,7.61H1.473L1.434,4.58c0-.058-.03-.1-.066-.1H1.324c-.036,0-.066.046-.066.1L1.218,7.61H.953L.914,4.58c0-.058-.03-.1-.066-.1H.8c-.036,0-.066.046-.066.1L.7,7.61H.506L.436,4.583c0-.059-.03-.107-.066-.107h0c-.035,0-.064.044-.066.1L.2,7.61H1.97Z",
    transform: "translate(-0.174 -3.885)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9281",
    "data-name": "Tracciato 9281",
    d: "M3.134,73.178l1.04,1.036L4.125,73.1l-.947-.944Z",
    transform: "translate(-2.72 -62.625)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9282",
    "data-name": "Tracciato 9282",
    d: "M.007,29.095H1.815A.9.9,0,0,0,1.822,29l-.027-.8H.027L0,29a.9.9,0,0,0,.007.092",
    transform: "translate(0 -24.481)",
    fill: "#8dcbca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9283",
    "data-name": "Tracciato 9283",
    d: "M1.719,35.558a.673.673,0,0,0,.159-.374H.076a.671.671,0,0,0,.159.374,1.828,1.828,0,0,1,.425.514h.634a1.824,1.824,0,0,1,.425-.514",
    transform: "translate(-0.066 -30.537)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9284",
    "data-name": "Tracciato 9284",
    d: "M.058,34.967h1.8c0-.011,0-.022,0-.033H.055c0,.011,0,.022,0,.033",
    transform: "translate(-0.048 -30.32)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9285",
    "data-name": "Tracciato 9285",
    d: "M144.846,11.7V4.358c0-.025-.077-.038-.172.017V11.7Z",
    transform: "translate(-125.567 -3.764)",
    fill: "#8dcbca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9286",
    "data-name": "Tracciato 9286",
    d: "M143.714,65.217v-5.1h-.343v6.136h.013c.35,0,.355-.477.33-1.037",
    transform: "translate(-124.436 -52.179)",
    fill: "#eb6947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9287",
    "data-name": "Tracciato 9287",
    d: "M138.245,60.119l-.457,5.1c-.025.561.386,1.037.736,1.037h0V60.119Z",
    transform: "translate(-119.589 -52.179)",
    fill: "#d33326"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9288",
    "data-name": "Tracciato 9288",
    d: "M135.436,34.87a.734.734,0,0,0,.17.5c.137.142.576.379.6.638h.452l.01-2.517-1.156-1.152c-.063,1.323-.075,2.531-.075,2.531",
    transform: "translate(-117.549 -28.068)",
    fill: "#8dcbca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9289",
    "data-name": "Tracciato 9289",
    d: "M136.112,26.564l1.141,1.137v-.575l-1.109-1.105c-.012.18-.022.362-.032.543",
    transform: "translate(-118.135 -22.584)",
    fill: "#8dcbca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9290",
    "data-name": "Tracciato 9290",
    d: "M136,30.427l1.156,1.152v-.306l-1.141-1.137q-.008.146-.015.291",
    transform: "translate(-118.039 -26.156)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9291",
    "data-name": "Tracciato 9291",
    d: "M138.2,4.629a1.146,1.146,0,0,0-.846.7,7.067,7.067,0,0,0-.139.832l1,.992Z",
    transform: "translate(-119.091 -4.018)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9292",
    "data-name": "Tracciato 9292",
    d: "M136.389,22.348c-.013.158-.024.321-.035.485l1.109,1.105v-.52Z",
    transform: "translate(-118.345 -19.396)",
    fill: "#bee1e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9293",
    "data-name": "Tracciato 9293",
    d: "M137.692,17.232l-1-.992c-.03.248-.056.521-.079.807l1.074,1.071Z",
    transform: "translate(-118.575 -14.095)",
    fill: "#8dcbca"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish);
export default __webpack_public_path__ + "static/media/dish.2f1d9c2477ef36df1956cefe4062554f.svg";
export { ForwardRef as ReactComponent };